<template>
  <input-select :options="parcelas" required name="Parcelas" label="Prazo" v-model="model" @change="change"></input-select>
</template>

<script>
export default {
  props: {
    value: null,
  },
  data () {
    return {
      parcelas: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    change (value) {
      this.$emit('change', value)
    },
    setParcela (loading) {
      const ultima = this.parcelas && this.parcelas.length > 0 ? this.parcelas[this.parcelas.length - 1].value : null
      if (!loading && this.model.Parcelas > ultima) { this.$set(this.model, 'Parcelas', ultima) }
    }
  },
  beforeMount () {
    const th = this
    th.$api.Multiplo.Post('ListProdutoRedeParcela', {}).then(function (response) {
      th.parcelas = []
      for (var i = 0; i < response.length; i++) {
        var obj = { value: response[i], text: response[i] + 'x' }
        th.parcelas.push(obj)
      }
      th.setParcela(true)
      th.$emit('load', th.parcelas.length < 6)
    })
  }
}
</script>
